import PaymentMethodList from './PaymentMethodList';
export default PaymentMethodList;
